module.exports = {
    someErrorOccured: 'Some error occured while saving record. Check log for more info.',
    noResponseFromServer: 'The server did not return any response. Check log for more info.',
}